<template>
<v-card outlined>
    <v-data-table
        :headers="headers"
        :items="list"
        :items-per-page="-1"
        :loading="fetching"
        hide-default-header
        hide-default-footer
        disable-pagination
        disable-filtering
        >
        <!-- eslint-disable-next-line -->
        <template v-slot:item.horario="{ item }">
            <v-chip label outlined small>
                {{ item.juego }} - {{ item.horario }} 
            </v-chip>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.venta="{ item }">
            <Venta :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.comision="{ item }">
            <Comision :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.premio="{ item }">
            <Premio :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.total="{ item }">
            <Total :reporte="item"/>
        </template>
    </v-data-table>
</v-card>
</template>

<script>
import ReporteService from '@/services/institution/ReporteService';

import Venta from '@/components/entities/reporte/components/venta.vue';
import Comision from '@/components/entities/reporte/components/comision.vue';
import Premio from '@/components/entities/reporte/components/premio.vue';
import Total from '@/components/entities/reporte/components/total.vue';

export default {
    components: {   
        Venta,
        Comision,
        Premio,
        Total,
    },
    props: {
        params: {
            defaults: function() {
                return {};
            },
        },
    },
    data: function() { 
        return {
            list: [],
            fetching: false,
            expanded: [],
        }
    },
    computed: {
        headers: function () {
            return [
                { text: 'Juego', align: 'start', value: 'horario' },
                { text: 'Ventas', value: 'venta' },
                { text: 'Comisión', value: 'comision' },
                { text: 'Premios', value: 'premio' },
                { text: 'Total', value: 'total'},
            ];
        },
    },
    methods: {
        fetch: async function () {
            this.fetching = true;
            this.list = [];

            const params = { ... this.params };

            try {
                const {
                    list
                } = await ReporteService.VentaPorSorteo(params);

                this.list = list;
            } catch (error) {
                // ERROR
            }

            this.fetching = false;
        },
    },
    watch: {
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    },
    mounted: function () {
        this.fetch();
    }
}
</script>